export const APP_CONSTANT = {
  DEFAULT_PAGE_SIZE: 15,
  PASSWORD_PATTERN: '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=\\S+$).{8,}$',
};
